import { withBemMod } from '@bem-react/core';

import { cnButton } from '../Button.cn';

export interface IButtonTypeResetProps {
    /**
     * Тип кнопки
     */
    type?: 'reset';
}

/**
 * @param {IButtonTypeResetProps} props
 */
export const withTypeReset = withBemMod<IButtonTypeResetProps>(cnButton(), { type: 'reset' });
